import { useState, useEffect } from 'react';
import { useSelector } from "react-redux";
import { getSchools, updatePupilDetails, getDataResource, getStudent} from '../../services/scpApi';
import BaselineAssessmentForm from "../../features/baselineAssessmentForm/BaselineAssessmentForm";
import DatePicker from "react-datepicker";
import SaveButton from "../../features/saveButton/SaveButton";

const Baseline  = () => {
    const [formData, setFormData] = useState({
        school: '',
        baselineAssessment: '',
        baselineAssessmentCompletedDate: '',
    });
    const [latestPeriod, setLatestPeriod] = useState({});
    const [schools, setSchools] = useState([]);
    const [validationErrors, setValidationErrors] = useState([]);
    const [assessmentSchema, setAssessmentSchema] = useState(null);
    const selectedStudent = useSelector(state => state.portalSelected.selectedStudent);
    const [student, setStudent] = useState({});
    const [loading, setLoading] = useState(null);


    useEffect(() => {

        if (!selectedStudent || !selectedStudent.id) {
            setStudent({});
            return;
        }

        (async () => {
            try {
                const studentData = await getStudent(selectedStudent.id);
                setStudent(studentData);

            } catch (error) {
                console.log(error);
            }
        })();

    }, [selectedStudent])
    

    // prepare form data for editing existing student
    useEffect(() => {
        if (!student) {
            return;
        }

        (async () => {
            try {
                // get assessment schema
                const blankAssessmentSchema = await getDataResource('maths-assessment');

                // set form data for updating student
                if (student) {
                    const mostRecentPeriod = student.pupil_periods[student.pupil_periods.length - 1] || {};
                    setLatestPeriod(mostRecentPeriod);

                    // set the form data baseline assessment = assessment schema if it doesn't already exist
                    if (!student.baseline_assessment) {
                        handleBaselineChange(blankAssessmentSchema);
                        setAssessmentSchema(blankAssessmentSchema);
                    }
                    
                    // otherwise use the existing baseline assessment as the schema
                    else {
                        setAssessmentSchema(student.baseline_assessment);
                    }

                    const newFormData = {
                        school: student.school.id || '',
                        baselineAssessment: student.baseline_assessment || blankAssessmentSchema,
                        baselineAssessmentCompletedDate: student.baseline_assessment_completed_date || '',
                    };
        
                    setFormData(newFormData);
                }
            } catch (error) {
                console.error('Error fetching assessment schema:', error);
            }
        })();

    }, [student]);

    // get schools for select
    useEffect(() => {
        (async () => {
            try {
                const schoolsData = await getSchools();
                setSchools(schoolsData);
            } catch (error) {
                console.error('Error fetching schools:', error);
            }
        })();
    }, []);


    // handle form data changes
    const handleChange = (e) => {
        // unset validation errors
        setValidationErrors([]);

        // handle form data change
        const { name, value } = e.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };

    // handle baseline assessment change
    const handleBaselineChange = (baselineAssessment) => {
        setFormData(prevData => ({
            ...prevData,
            baselineAssessment
        }));

        console.log('baseline assessment changed:', baselineAssessment);
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        setValidationErrors([]);
        setLoading('loading');

        console.log('completion date:', formData.interventionCompletedDate);

        // save student
        try {
            if (student) {
                // Editing existing student
                await updatePupilDetails({
                    studentId: student.id,
                    school: formData.school,
                    name: formData.name,
                    baselineAssessment: formData.baselineAssessment,
                    baselineAssessmentCompletedDate: formData.baselineAssessmentCompletedDate,
                    interventionCompletedDate: formData.interventionCompletedDate
                });

                setLoading('success');

            } else {
                return;
            }
        } catch (error) {
            // server side validation
            const errors = [];

            if (error.response.data.errors) {
                Object.keys(error.response.data.errors).forEach((key) => {
                    errors.push(error.response.data.errors[key]);
                });
            } else if (error.response.data.message) {
                errors.push(error.response.data.message);
            }
            setValidationErrors(errors);
            console.error('Error saving student:', error);

            setLoading('error');
            setTimeout(() => {
                setLoading(null);
            }, 3000);
        }
    };

    return (
        <div className="single-edit">
            <form onSubmit={handleSubmit}>
                <label>Baseline Assessment Completed Date:</label>
                <div className="date-selector-cont">
                    <DatePicker
                        selected={formData.baselineAssessmentCompletedDate ? new Date(formData.baselineAssessmentCompletedDate) : null}
                        onChange={(date) => handleChange({ target: { name: 'baselineAssessmentCompletedDate', value: date } })}
                        dateFormat="dd/MM/yyyy"
                        placeholderText="Select Date"
                    />
                </div>

                <div>

                <label>Baseline Assessment:</label>
                <span className="field-instruction">Click the level boxes to toggle status. Hold ctrl and click to fill in all previous levels of a single topic.</span>
                {assessmentSchema ?
                    <BaselineAssessmentForm 
                        baselineAssessment={formData.baselineAssessment} 
                        handleBaselineChange={(baselineAssessment) => handleBaselineChange(baselineAssessment)} 
                    />
                    :
                    <div className="loading baseline-assessment-form"></div>
                }
                </div>

                <div className="flex-row-buttons-cont">
                    <SaveButton
                        save={handleSubmit}
                        loading={loading}
                        textCreate="Save Baseline"
                        textCreateLoading="Saving..."
                        textCreateSuccess="Saved"
                        textCreateError="Error"
                        textUpdate="Update Baseline"
                        textUpdateLoading="Updating..."
                        textUpdateSuccess="Updated"
                        textUpdateError="Error"
                        isUpdating={!!student} 
                    />
                </div>

                {validationErrors.length > 0 &&
                    <div className="error-messages">
                        {validationErrors.map((error, index) => {
                            return <p key={index}>{error}</p>
                        })}
                    </div>
                }
            </form>
        
        </div>
    );
}
export default Baseline;